import { QRCode } from 'antd';
import { useState, useEffect } from 'react';
import { Flex, LoadingSpin } from '../common';
import { parseError } from '@/utils';
import { isExeedForgottenCode } from '@/services/http';
import { useTranslation } from 'react-i18next';

export default function QRCodeLoadAction({ action }) {
  const [t] = useTranslation(['common', 'reseve']);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [code, setCode] = useState(null);

  useEffect(() => {
    setError('');
    setLoading(true);
    action()
      .then(res => setCode(res?.data?.payload?.forgotCardCode))
      .catch(e => setError(isExeedForgottenCode(e) ?
        t('reserve:errors.limit-forgotten-card-usage') :
        parseError(e))
      )
      .finally(() => {
        setLoading(false);
      });
  }, [action, t]);

  return (
    loading ? (
      <Flex className="h-full w-full" justify="center" align="center">
        <LoadingSpin className="m-auto" text="" />
      </Flex>
    ) : (
      error ? (
        <Flex direction="column" justify="center" align="center">
          <b className="w-full text-center text-red-500">{error}</b>
        </Flex>
      ) : (
        <Flex direction="column" justify="center" align="center">
          <QRCode value={code} size={120} />
          <b className="w-full text-center">{code}</b>
        </Flex>
      )
    )
  );
}
